import type { FC, ReactNode } from 'react'
import L from 'leaflet'
import { Marker } from 'react-leaflet'

interface CustomPlaceMarkerProps {
    position:  L.LatLngExpression
    children?: ReactNode
}

const CustomPlaceMarker: FC<CustomPlaceMarkerProps> = ({ position, children }) => {

    const customIcon = L.icon({
        iconUrl: '/pin-place-blue.png',
        iconSize: [42, 48],
        iconAnchor: [22, 36],
    })

    return (
        <Marker position={position} icon={customIcon}>
            {children}
        </Marker>
    )
}

export default CustomPlaceMarker
